<template>
  <CardLoaderSmall v-if="isLoading" class="col-span-full md:col-span-4" />
  <box v-else class="col-span-full md:col-span-4">
    <h2 class="text-t4 mb-4 flex items-center gap-4">
      <IconTools class="w-[50px] h-[50px] md:w-[59px] md:h-[59px]" />
      Felanmälan
    </h2>
    <div class="flex flex-1 flex-col gap-4">
      <div class="flex flex-1 flex-col">
        <div v-if="getErrorReportsList && getErrorReportsList.workorders && getErrorReportsList.workorders.length > 0" class="flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <h3 class="text-b2">Pågående ärenden</h3>
            <Button variant="tertiary" size="small" :to="{ path: '/felanmalan' }">
              Visa alla
              <template #icon-after>
                <IconArrowRight />
              </template>
            </Button>
          </div>
          <div v-for="report in getErrorReportsList.workorders.slice(0, 3)">
            <div
              class="flex items-center justify-between gap-2 rounded-[4px] bg-dark-turquoise-10 px-3 py-1"
            >
              <div class="text-b1 text-left">{{ formatTitle(report.title)  }}</div>
              <div class="text-b3 text-right" v-if="report.registeredDate">{{ formatDate(report.registeredDate) }}</div>
              <div class="text-b3 text-right" v-else>{{ formatDate(report.lastUpdatedDate) }}</div>
            </div>
          </div>
          <div class="text-b3 text-center" v-if="getErrorReportsList.workorders.length">
            Visar
            {{ getErrorReportsList.workorders.slice(0, 3).length }} av
            {{ getErrorReportsList.workorders.length }}
          </div>
        </div>
        <div v-else-if="hasActiveOrTerminatedContract" class="flex h-20 flex-1 flex-col items-center justify-center gap-2">
          <IconHouseBlank />
          <p class="text-center">
            Härligt! Inga fel är anmälda {{ prep }}
            <br />
            {{objectType}} just nu.
          </p>
        </div>
        <div v-else-if="!hasActiveOrTerminatedContract && !this.hasApartment && !this.hasStorage && !this.hasParking && !this.isLoading" class="flex h-20 flex-1 flex-col items-center justify-center gap-2">
          <IconHouseBlank />
          <p class="text-center">
            Du har för närvarande inget hyresavtal hos Gavlegårdarna
          </p>
        </div>
      </div>
      <div v-if="hasActiveOrTerminatedContract && notPremiseCompany" class="flex items-end justify-end">
        <Button :to="{ path: '/felanmalan/skapa' }" size="large" @click="trackClick">Anmäl ett fel</Button>
      </div>
    </div>
  </box>
</template>

<script>
import Box from '@/components/ui/box';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import IconTools from '@/components/icons/IconTools';
import IconArrowRight from '@/components/icons/IconArrowRight';
import Button from '@/components/ui/button';
import { mapGetters } from 'vuex';
import IconHouseBlank from '@/components/icons/IconHouseBlank';
import { dataLayerPush } from '@/helpers/datalayer'
import {filter} from "lodash";

export default {
  name: 'DashboardErrorReporting',
  components: {
    Box,
    CardLoaderSmall,
    Button,
    IconArrowRight,
    IconHouseBlank,
    IconTools,
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      // testAlwaysLoading: true, // Set to true to force loading state, false for normal behavior
    };
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      getErrorReportsList: 'getErrorReportsList',
      hasParking: 'hasParking',
      hasStorage: 'hasStorage',
      hasApartment: 'hasApartment',
      hasActiveOrTerminatedContract: 'hasActiveOrTerminatedContract',
      contracts: 'contracts'
    }),

    isCompany() {
      return this.$store.getters.claims.some((el) => el == 'company');
    },

    notPremiseCompany() {
      if (!Array.isArray(this.contracts) || this.contracts.length === 0) return false;
      if (!this.isCompany) return true;
      const disAllowedTypes = ['LOK1', 'LOK2', 'LOK4'];
      return !this.contracts.some(contract =>
        contract.rentalObject?.rentalObjectTypeCode &&
        disAllowedTypes.includes(contract.rentalObject.rentalObjectTypeCode)
      );
    },

    objectType() {
      if (this.hasApartment) {
        return "bostad";
      }
      else if (this.hasParking) {
        return "fordonsplats";
      }
      else if (this.hasStorage) {
        return "lokal";
      }
      else return "bostad";
    },

    prep() {
      if (this.hasParking) {
        return "vid din";
      }
      else return "i din";
    }
  },
  watch: {
    startLoading: {
      immediate: true,
      handler(val) {
        if (val === true) {
          new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
            this.$store.cache.dispatch('fetchProfile').then((profile) => {
              this.$store.cache.dispatch('fetchErrorReportsList', profile.contactCode).then(() => {
                this.$store.cache.dispatch('fetchContracts').then(() => {
                  this.isLoading = false;
                });
              });
            });
          });
        }
      }
    },
  },
  created() {
  },


  methods: {
    formatDate(dateString) {
      return new Date(dateString).toISOString().split('T')[0];
    },
    formatTitle(title) {
      if (!title) return;
      let altTitle = title.split(" - ");
      return altTitle[0].split('Från webb: ').join('');
    },
    trackClick() {

      dataLayerPush({
        'event': 'serviceRequest',
        'step': 'Dashboard'
      });
    }
  },
};
</script>
